import React from 'react';
import { useLocation } from 'react-router-dom';
import { Clock3 } from 'lucide-react';
import Header from './Header';
import Footer from './Footer';
import MobileBottomBar from './MobileBottomBar';
import WhatsAppButton from './WhatsAppButton';
import Logo from './Logo';
import { Toaster } from './ui/toaster';
import { useSettings } from '../contexts/SettingsContext';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';

const MaintenanceNotice = () => {
  const { lang } = useLanguage();
  return (
    <div className="flex-1 flex items-center justify-center px-4 py-24 text-center">
      <div>
        <Logo className="h-16 w-16 mx-auto mb-4" />
        <Clock3 className="w-10 h-10 mx-auto mb-4 text-gold-500" />
        <h1 className="text-2xl md:text-3xl font-bold text-[#171412] mb-2" style={{ fontFamily: "'Amiri', serif" }}>
          {lang === 'ar' ? 'سنعود قريباً' : "We'll be back soon"}
        </h1>
        <p className="text-[#171412]/60 max-w-sm mx-auto">
          {lang === 'ar'
            ? 'الموقع تحت الصيانة حالياً، يرجى المحاولة لاحقاً.'
            : "The site is temporarily down for maintenance. Please check back shortly."}
        </p>
      </div>
    </div>
  );
};

const Layout = ({ children }) => {
  // The glassy mobile bottom nav shows on every customer-facing page (admin routes don't
  // go through this Layout at all, so no extra exclusion is needed here).
  const { pathname } = useLocation();
  const { settings } = useSettings();
  const { isAdmin } = useAuth();
  // /login and /register stay reachable even in maintenance mode so the admin can sign in
  // and flip the toggle back off — everything else shows the notice for non-admin visitors.
  const isAuthPage = pathname === '/login' || pathname === '/register';
  const maintenanceBlocked = settings.maintenanceMode && !isAdmin && !isAuthPage;

  return (
    <div className="min-h-screen flex flex-col bg-[#FFFFFF]">
      <Header />
      {maintenanceBlocked ? (
        <MaintenanceNotice />
      ) : (
        <main className="flex-1 pb-16 md:pb-0">{children}</main>
      )}
      <Footer />
      <Toaster />
      {!maintenanceBlocked && <MobileBottomBar />}
      {!maintenanceBlocked && <WhatsAppButton />}
    </div>
  );
};

export default Layout;
